import * as pc from 'playcanvas';

export function extractClientCoordFromEvent( pointers: Iterable<{ clientX: number, clientY: number }>, out: pc.Vec2 ) {

	out.set( 0, 0 );
	let count = 0;

	for ( const pointer of pointers ) {

		out.x += pointer.clientX;
		out.y += pointer.clientY;
		count ++;

	}

	if ( count > 0 ) {

		out.x /= count;
		out.y /= count;

	}

}